import React from "react";
import styled from "styled-components";
import { Box } from "../Box";
import { style } from "../style";
import { VPCNote } from "./VPCNote";

const Container = styled.div`
  all: unset;
  color: ${style.colors.grey.darkest};
`;

const VPCNameText = styled.strong`
  all: unset;
  font-weight: ${style.vars.fontWeight.bold};
`;

type Props = {
  /**
   * The name attached to the hidden input for the VPC.
   */
  name: string;

  /**
   * The value of the VPC.
   */
  selected: string;

  /**
   * Testing utility tag.
   * @default "vpc-single-value"
   */
  "data-testid"?: string;
};

export const VPCSingleValue: React.FC<Props> = (props) => {
  const { name, selected } = props;
  const testId = props["data-testid"] ?? "vpc-single-value";

  return (
    <div data-testid={testId}>
      <Container>
        VPC network - <VPCNameText>{selected}</VPCNameText>
        <input type="hidden" name={name} value={selected} />
      </Container>
      <Box display="block" mt={2}>
        <VPCNote />
      </Box>
    </div>
  );
};
